import React from 'react';

import Select, { MultiValue, Props as SelectProps, SingleValue } from 'react-select';

import ClearIndicator from 'components/SelectIndicators/ClearIndicator';
import SelectWrapper from 'components/SelectWrapper';
import useMobileCheck from 'hooks/useMobileCheck';
import useTabletCheck from 'hooks/useTabletCheck';
import { formatOptionLabel, getDefaultCustomStyles, OptionType } from 'utils/inputSelect';

export interface InputSelectProps extends SelectProps<OptionType> {
  label?: string;
  errorMessage?: string;
  caption?: string;
  inputContainerClassName?: string;
  inputClassName?: string;
  noInteraction?: boolean | null;
  placeholder?: string;
  onChangeControl?: (option: string) => void;
  onChange?: (option: MultiValue<OptionType> | SingleValue<OptionType>) => void;
  isClearable?: boolean;
}

const SelectBase = ({
  label,
  errorMessage,
  caption,
  inputContainerClassName,
  inputClassName,
  noInteraction,
  onChangeControl,
  onChange,
  placeholder = '',
  isDisabled,
  isClearable,
  ...rest
}: InputSelectProps) => {
  const isTablet = useTabletCheck();
  const isMobile = useMobileCheck();

  const handleChange = (value: MultiValue<OptionType> | SingleValue<OptionType>) => {
    if (onChangeControl && !value) {
      onChangeControl('');
    }

    if (onChangeControl && value) {
      onChangeControl((value as OptionType).label);
    }

    if (onChange && value) {
      onChange(value);
    }
  };

  return (
    <SelectWrapper
      label={label}
      inputContainerClassname={inputContainerClassName}
      errorMessage={errorMessage}
      loading={noInteraction}
      isDisabled={isDisabled}
    >
      <Select
        components={{ ClearIndicator: ClearIndicator }}
        formatOptionLabel={formatOptionLabel}
        styles={getDefaultCustomStyles({
          error: errorMessage || '',
          loading: !!noInteraction,
          disabled: isDisabled,
          isTablet: isTablet,
          isMobile: isMobile,
        })}
        placeholder={placeholder}
        onChange={handleChange}
        isDisabled={isDisabled}
        isClearable={isClearable}
        {...rest}
      />
    </SelectWrapper>
  );
};

export default SelectBase;
